import styled from "styled-components";

export default styled.div`
  margin-top: 15px;

  .title {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.87);
    line-height: 28px;
    letter-spacing: 0.48px;
    margin-bottom: 10px;
    padding-top: 10px;
  }
`;
